import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { getUser, logout } from '../../services';

export const DropdownLoggedIn = ({ setDropdown }) => {
	const navigate = useNavigate();

	const [user, setUser] = useState({ email: '' });

	useEffect(() => {
		async function fetchUser() {
			try {
				const currentUser = await getUser();
				currentUser.email ? setUser(currentUser) : handleLogout();
			} catch (err) {
				toast.error(`${err.message}`, {
					closeButton: false,
					position: 'top-center', // modified to "center-center" in index.css
					autoClose: 5000,
					closeOnClick: true
				});
			}
		}
		fetchUser();
	});

	const handleLogout = () => {
		logout();
		setDropdown(false);
		navigate('/');
	};

	return (
		<div
			id='dropdownAvatar'
			className='text-left select-none	absolute top-10 right-0 z-10 w-36 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'
		>
			<div className='py-3 px-4 text-sm text-gray-900 dark:text-white'>
				<div className='font-medium truncate'>{user.email}</div>
			</div>
			<ul
				className='py-1 text-sm text-gray-700 dark:text-gray-200'
				aria-labelledby='dropdownUserAvatarButton'
			>
				<li>
					<Link
						onClick={() => setDropdown(false)}
						to='/products'
						className='block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
					>
						All eBooks
					</Link>
				</li>
				<li>
					<Link
						onClick={() => setDropdown(false)}
						to='/dashboard'
						className='block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
					>
						Dashboard
					</Link>
				</li>
			</ul>
			<div className='py-1'>
				<span
					onClick={handleLogout}
					className='cursor-pointer block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white'
				>
					Log out
				</span>
			</div>
		</div>
	);
};
